import { ChunkStage, World, WorldName } from './world';
import { ParallaxType, ParallaxDirection } from '../../core/modules/Parallax/ParallaxController';
import { RelicName } from '../relics/relic';
import { ChunkConditions } from '../ChunkConditions';

import ShipwreckStartChunk from '../chunks/shipwreck/ShipwreckStartChunk';
import ShipwreckEndChunk from '../chunks/shipwreck/ShipwreckEndChunk';
import ShipwreckChunk1 from '../chunks/shipwreck/ShipwreckChunk1';
import ShipwreckChunk2 from '../chunks/shipwreck/ShipwreckChunk2';
import ShipwreckChunk3 from '../chunks/shipwreck/ShipwreckChunk3';
import ShipwreckChunk4 from '../chunks/shipwreck/ShipwreckChunk4';
import ShipwreckChunkRelic1 from '../chunks/shipwreck/ShipwreckChunkRelic1';
import ShipwreckChunkRelic2 from '../chunks/shipwreck/ShipwreckChunkRelic2';
import ShipwreckOnboardingChunk from './../chunks/shipwreck/ShipwreckOnboardingChunk';
import ShipwreckChunkHard1 from '../chunks/shipwreck/ShipwreckChunkHard1';
import ShipwreckChunkHard2 from '../chunks/shipwreck/ShipwreckChunkHard2';
import ShipwreckChunkHard3 from '../chunks/shipwreck/ShipwreckChunkHard3';
import ShipwreckChunkHard4 from '../chunks/shipwreck/ShipwreckChunkHard4';

export const shipwreckWorld: World = {
  id: WorldName.Shipwreck,
  texture: 'game-all',
  parallaxLayers: [
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -530,
      y: 384,
      texture: 'game-all',
      images: [
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.jpg',
          gapBefore: -2
        }
      ],
      depth: 1,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.5,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -320,
      y: 439,
      texture: 'game-all',
      images: [
        {
          frame: 'tile-back-cloud.png',
          gapBefore: -2
        },
        {
          frame: 'tile-back-cloud.png',
          gapBefore: -2
        },
        {
          frame: 'tile-back-cloud.png',
          gapBefore: -2
        }
      ],
      depth: 2,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.15,
      speedY: 0,
      naturalDriftX: 0.15,
      naturalDriftY: 0
    },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 300,
      texture: 'game-all',
      images: [
        {
          frame: 'tile-clouds-2.png'
        },
        {
          frame: 'tile-clouds-1.png',
          gapAfter: 600
        },
        {
          frame: 'tile-clouds-2.png'
        },
        {
          frame: 'tile-clouds-1.png',
          gapAfter: 600
        }
      ],
      depth: 3,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.2,
      speedY: 0,
      naturalDriftX: 0.35,
      naturalDriftY: 0
    },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -672,
      y: 300,
      texture: 'game-all',
      images: [
        {
          frame: 'tile-sea.png',
          gapBefore: -1
        },
        {
          frame: 'tile-sea.png',
          gapBefore: -1
        },
        {
          frame: 'tile-sea.png',
          gapBefore: -1
        }
      ],
      depth: 4,
      scrollX: 0,
      scrollY: 1,
      speedX: 0.75,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    }
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 300,
    //   width: 1920,
    //   height: 87,
    //   texture: 'game-all',
    //   frame: 'tile-sea.png',
    //   depth: 4,
    //   scrollX: 0,
    //   scrollY: 1,
    //   speedX: 0.75,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // }
  ],
  playerSpawnPoint: { x: 100, y: -20 },
  hasHardFloor: true,
  deathFloorY: 300,
  chunkStartX: 0,
  chunkStartY: 300,
  relics: [
    {
      relic: RelicName.BronzeBoots,
      distance: 15000,
      chunks: [ShipwreckChunkRelic2]
    },
    {
      relic: RelicName.GoldenWings,
      distance: 30000,
      chunks: [ShipwreckChunkRelic1]
    }
  ],
  chunks: {
    [ChunkStage.Start]: [ShipwreckStartChunk],
    [ChunkStage.Onboarding]: [ShipwreckOnboardingChunk],
    [ChunkStage.Easy]: [ShipwreckChunk1, ShipwreckChunk2, ShipwreckChunk3, ShipwreckChunk4],
    // [ChunkStage.Easy]: [ShipwreckChunkHard1, ShipwreckChunkHard2, ShipwreckChunkHard3, ShipwreckChunkHard4],
    [ChunkStage.Hard]: [
      ShipwreckChunk1,
      ShipwreckChunk2,
      ShipwreckChunk3,
      ShipwreckChunk4,
      ShipwreckChunkHard1,
      ShipwreckChunkHard2,
      ShipwreckChunkHard3,
      ShipwreckChunkHard4
    ],
    [ChunkStage.End]: [ShipwreckEndChunk]
  },
  stageOrdering: [
    {
      name: ChunkStage.Start,
      count: 1
    },
    {
      name: ChunkStage.Onboarding,
      count: 1,
      conditions: [ChunkConditions.SkipAfterMinimumProgress]
    },
    {
      name: ChunkStage.Easy,
      distance: 37500,
      // count: 1,
      rushMax: 0
    },
    {
      name: ChunkStage.Hard,
      distance: 37500,
      // count: 1,
      rushMin: 1
    },
    {
      name: ChunkStage.End,
      count: 1
    }
  ]
};
